import Message from "@/utils/message"
export default [
    (config: any) => {
        if (config.showProgress !== false) {
            config.showProgress = true
        }
        if (config.showError !== false) {
            config.showError = true
        }
        return config
    },
    (error: any) => {
        if (error && error.config && error.config.showError) {
            Message.error("请求错误")
        }
        return Promise.reject(error)
    }
]
